import React from "react"
import {IndexRoute, Redirect, Route, Switch, withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {push} from 'react-router-redux';
import Notifications from './components/layout/notifications';
import Navbar from './components/layout/navbar';
import Dashboard from './components/dashboard';
import GameIndex from './components/game/index';
import GameCreate from './components/game/create';
import GameEdit from './components/game/edit';
import InitScreen from "./components/init-screen";
import GameIntro from "./components/game-intro";
import SignIn from './components/auth/sign-in';
import LecturerIndex from './components/auth/lecturer';
import Profile from "./components/auth/profile";
import StudentsSignIn from './components/auth/students/sign-in';
import Footer from './components/layout/footer';
import Rules from './components/rules';
import Background from './components/background';

class StaticLayout extends React.Component {
    render() {
        const { mainClass } = this.props;

        return (
            <div id='body-container' className={mainClass}>
                <Navbar/>
                <div className='clearfix'>&nbps;</div>
                <div id='main-container' className='content'>
                    <Background/>
                    <Notifications/>
                    { this.props.children }
                </div>
                <Footer/>
            </div>
        )
    }
}

class App extends React.Component {

    render() {
        let inGame = this.props.location && this.props.location.pathname.startsWith('/game/');
        let working = this.props.gameInstance.loading
            || this.props.gameInstance.sendingInput
            || this.props.creativeTasks.loading
            || this.props.creativeTasks.sendingInput
            || this.props.bonusTasks.loading
            || this.props.bonusTasks.sendingInput;

        let mainClass = `header-fixed theme-${this.props.theme.name} ${working ? 'busy' : ''} ${inGame ? 'in-game' : ''}`;

        if (this.props.auth.authenticating || !this.props.auth.isAuthenticated) {
            return (
                <Switch>
                    <Route path='/lecturers' render={() => <StaticLayout mainClass={mainClass}><LecturerIndex/></StaticLayout>}/>
                    <Route path='/students/sign-in' render={() => <StaticLayout mainClass={mainClass}><StudentsSignIn/></StaticLayout>}/>
                    <Route path='/sign-in' render={() => <StaticLayout mainClass={mainClass}><SignIn/></StaticLayout>}/>
                    <Route path='/zapoj-se' render={() => <StaticLayout mainClass={mainClass}><GameIntro/></StaticLayout>}/>
                    <Route path="/pravidla" render={() => <Rules mainClass={mainClass}/>}/>
                    <Route path='/' render={() => <StaticLayout mainClass={mainClass}><InitScreen/></StaticLayout>}/>
                    <Redirect to='/'/>
                </Switch>
            );
        }

        return (
            <Switch>
                <Route path="/profile" render={() => <StaticLayout mainClass={mainClass}><Profile/></StaticLayout>}/>
                <Route path="/game-new" render={() => <StaticLayout mainClass={mainClass}><GameCreate/></StaticLayout>}/>
                <Route path="/game-edit/:id" render={() => <StaticLayout mainClass={mainClass}><GameEdit/></StaticLayout>}/>
                <Route path="/game/:id" render={() => <GameIndex mainClass={mainClass}/>}/>
                <Route path="/pravidla" render={() => <StaticLayout mainClass={mainClass}><Rules/></StaticLayout>}/>
                <Route path="/dashboard" render={() => <StaticLayout mainClass={mainClass}><Dashboard/></StaticLayout>}/>
                <Redirect to='/dashboard'/>
            </Switch>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        gameInstance: state.gameInstance,
        creativeTasks: state.creativeTasks,
        bonusTasks: state.bonusTasks,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        push: push
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(App));
